import request from '@/utils/request'

let Ma_safety_trainingApi = {

  /*安全培训列表*/
  list(data) {
    return request._post('/shop/plus.ma_safety_training.Index/index', data);
},
/*添加安全培训*/
add(data) {
    return request._post('/shop/plus.ma_safety_training.Index/add', data);
},
/*修改安全培训*/
edit(data) {
    return request._post('/shop/plus.ma_safety_training.Index/edit', data);
},
/*删除安全培训*/
del(data) {
    return request._post('/shop/plus.ma_safety_training.Index/del', data);
},
/*安全培训详情*/
detail(data) {
  return request._post('/shop/plus.ma_safety_training.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_safety_training.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_safety_training.Setting/getSetting', data, errorback);
    },
}
export default Ma_safety_trainingApi;



// WEBPACK FOOTER //
// ./src/api/ma_safety training.js